//
// 03/05/2019 note:
// When changing any site settings, be sure to follow the process in the "Settings Support Work In-take Process" wiki page:
//    https://mytableau.tableaucorp.com/x/coDWD
//

import _ from 'underscore';

import { getAppStore } from '../../app/AppStore';
import { NavLocationSelectors } from '../../app/selectors/NavigationStateSelectors';
import * as SiteUrlsSelectors from '../../app/selectors/SiteUrlsSelectors';
import { ServerUrls } from '../../app/ServerUrls';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { ServerSettings, ServerSettingsInstance } from '../services/ServerSettings';
import { defaultEntry, defaultExtensionsSiteSettings, defaultUrl, Sites } from '../../ts/siteManagement/services/resources/Sites';
import { defaultDashExtServerSettings as defaultExtensionsServerSettings, defaultExtsvcServerSettings, IDashExtServerSettings as IExtensionsServerSettings, IExtsvcServerSettings } from '../../ts/ServerApi/types/IEditableServerSettings';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { DomainFamily } from '../types/IServerSettingsUnauthenticated';
import { getSessionManagementServiceInstance, SessionManagementService } from '../../sessionManagement/SessionManagementService';
import { ToasterService, ToastType } from '../../ts/services/ToasterService';
import { ISettingsCoordinatorCtrlScope, SettingsFormService } from '../directives/tbSettingsCoordinator';
import {
  ExtensionSafeListEntry,
  IDashExtSiteSettings as IExtensionsSiteSettings,
  Option
} from '../types/ISiteSettingsForSiteAdmin';
import { HelpService } from '../../commonInfra/services/HelpService';
import { ServerSettingsUnauthenticated } from '../services/ServerSettingsUnauthenticated';

export enum List {
  BlockList,
  SafeList
}

export interface IExtensionsSettings {
  site: IExtensionsSiteSettings;
  server: IExtensionsServerSettings;
  analyticsExtServerEnabled: IExtsvcServerSettings;
}

// an array of primitives is not editable in an ng-repeat element, so we need to make the urls into objects for the form
// https://stackoverflow.com/questions/15488342/binding-inputs-to-an-array-of-primitives-using-ngrepeat-uneditable-inputs
export interface EditableBlocklistItem {
  value: string;
}
// plus a mapper function
export function GetNonPrimitiveArray(primitives: string[]) {
  return _.map(primitives, (element) => { return {'value': element}; });
}


export interface IExtensionsSettingsCtrlScope extends ISettingsCoordinatorCtrlScope<IExtensionsSiteSettings>{
  extensionsSettingsFormModel: IExtensionsSettings;
  extensionsSettingsForm: ng.IFormController; // the form name given in extensionsSettingsForm.pug
  extensionsServerSettings: any;
  extensionsServerBlocklist: EditableBlocklistItem[];

  addNewSafelistEntry: ($event: JQuery.Event) => void;
  deleteSafelistEntry: (index: number) => void;
  addNewBlocklistEntry: ($event: JQuery.Event) => void;
  deleteBlocklistEntry: (index: number) => void;
  dataAccessOptions: Option[];
  userPromptOptions: Option[];
  FullDataAccess_LearnMoreLinkHref: string;
  learnMoreUrl: string;
  UserPrompts_LearnMoreLinkHref: string;
  URLHeaderInfo_LearnMoreLinkHref: string;
  showSiteSettings: boolean;
  showServerSettings: boolean;
  siteMatchesServer: boolean;
  showAnalyticsServerSetting: boolean;
  learnMoreAnalyticsExtUrl: string;
}

export class SiteSettingsForExtensionsCtrl {
  private serverSettings: ServerSettings;
  private master: IExtensionsSettings;

  public static $inject = [
    '$scope',
    '$q',
    '$location',
    '$translate',
    'SettingsFormService'
  ];

  constructor(
    private $scope: IExtensionsSettingsCtrlScope,
    private $q: ng.IQService,
    $location: ng.ILocationService,
    private $translate: ng.translate.ITranslateService,
            formService: SettingsFormService
  ) {
     // set up form model
    this.$scope.extensionsSettingsFormModel = {
      server: $scope.extensionsServerSettings,
      site: $scope.siteSettings,
      analyticsExtServerEnabled: $scope.extsvcServerSettings  // don't set while feature is behind a FF { enabled: true} //
    };
    this.serverSettings = ServerSettingsInstance;

    if (!$scope.siteSettings || ($scope.siteSettings as any).errors) {
      // we didn't get the current settings from the server, showing default settings
      this.$scope.extensionsSettingsFormModel.site = defaultExtensionsSiteSettings;

      let errorMessage: string = this.$translate.instant('unexpectedError');
      let reason: any = $scope.siteSettings;
      errorMessage = errorMessage.concat('\n ' + reason.errors[0].message);
      ToasterService.instance.pop({ type: ToastType.Error, text: errorMessage});
    }

    if ($scope.extensionsServerSettings == null || $scope.extensionsServerSettings.errors) {
      this.$scope.extensionsSettingsFormModel.server = defaultExtensionsServerSettings;

      let errorMessage: string = this.$translate.instant('unexpectedError');
      let reason: any = $scope.extensionsServerSettings;
      errorMessage = errorMessage.concat('\n ' + reason.errors[0].message);
      ToasterService.instance.pop({ type: ToastType.Error, text: errorMessage});
    }

    if (!$scope.extsvcServerSettings || ($scope.extsvcServerSettings as any).errors) {
      $scope.extensionsSettingsFormModel.analyticsExtServerEnabled = defaultExtsvcServerSettings;
    }else{
      this.$scope.extensionsSettingsFormModel.analyticsExtServerEnabled = $scope.extsvcServerSettings;
    }


    this.$scope.extensionsServerBlocklist = GetNonPrimitiveArray(this.$scope.extensionsSettingsFormModel.server.blocklist);
     // would be better if I could put ng-change on the tbTextBox but I don't know how to make that work
    $scope.$watch('extensionsServerBlocklist', ((newVal: string, oldVal: string) => {
      if (newVal !== oldVal){
        this.refreshBlocklistForServer();
      }
    }), true);

    // set up form state and actions
    this.master = angular.copy(this.$scope.extensionsSettingsFormModel);

    this.$scope.showResetSettingsBtn = () => false;
    this.$scope.sharedForm = formService;
    this.$scope.localForm = {
          busy: false,
          formController: this.$scope.extensionsSettingsForm,
          cancel: () => {
            this.$scope.extensionsSettingsFormModel = angular.copy(this.master);
            this.$scope.extensionsServerBlocklist = GetNonPrimitiveArray(this.master.server.blocklist);
          },
          isFormUnchanged: () => angular.equals(this.master, this.$scope.extensionsSettingsFormModel),
          isBusy: () => this.$scope.localForm.busy,
          onSave: null,
          resetForm: () => this.$scope.extensionsSettingsFormModel = angular.copy(this.master),
          save: () => this.$q.all([this.getExtensionSettingsUpdatePromise(), FeatureFlags.extSvcSiteLevelSettingsEnabled ? this.UpdateExtsvcServerSettings() : undefined]),
          resetSettings: null,
          updateFailure: null
    };

    const server = getSessionManagementServiceInstance();
    const siteUrls = SiteUrlsSelectors.siteUrlsSelector(getAppStore().getState());
    const extensionsServer = this.$scope.extensionsSettingsFormModel.server;
    const site = this.$scope.extensionsSettingsFormModel.site;
    const isMultiSite = server.isSessionMultiSite();
    const isOnline = server.isOnlineEnvironment();
    // Currently isMultiSite refers to the number of sites the user account is linked to. Ideally we should find the number of sites on the server and show the server settings if the number of sites is only one.
    // The problem is that if we are in the context of a user that doesn't have server admin permissions, the APIs that I tried, return values scoped to that user which is same as before.
    // As a workaround, we check to see if we are in online. The server blocklist should be present only on the server admin page in online. On on-prem installations, we revert to the previous logic.
    // Note1: The isMultiSite value is be valid for "Server Admins".
    // Note2: "Site Admins" dont have access to settings tab on OnPrem environments.
    const isSingleSiteOnPremAdministrator = (!isMultiSite && !isOnline);
    this.$scope.showServerSettings = ($location.path() === ServerUrls.getInstance().settingsExtensionsPath()) || isSingleSiteOnPremAdministrator;
    this.$scope.showSiteSettings = ($location.path() === siteUrls.settingsExtensionsPath()) || !isMultiSite;
    this.$scope.siteMatchesServer = isSingleSiteOnPremAdministrator && (extensionsServer.extensionsGloballyEnabled === site.extensionsEnabled);
    // should only show analytics server settings when user is OnPrem and multisite admin
    this.$scope.showAnalyticsServerSetting = (isMultiSite && !isOnline);

    // set up dropdown options
    const showOption = { name: this.$translate.instant('extensionsSiteSettings_whitelist_UserPrompts_Show'), value: true};
    const hideOption = { name: this.$translate.instant('extensionsSiteSettings_whitelist_UserPrompts_Hide'), value: false};

    const allowOption = { name: this.$translate.instant('extensionsSiteSettings_whitelist_FullDataAccess_Allow'), value: true};
    const denyOption =  {name: this.$translate.instant('extensionsSiteSettings_whitelist_FullDataAccess_Deny'), value: false};

    $scope.userPromptOptions =  [ showOption, hideOption ];
    $scope.dataAccessOptions = [ allowOption, denyOption ];

    $scope.learnMoreUrl = HelpService.getServerHelpUrlByCategory('extensions');
    $scope.URLHeaderInfo_LearnMoreLinkHref = HelpService.getServerHelpUrlByCategory('extensions');
    $scope.FullDataAccess_LearnMoreLinkHref = HelpService.getServerHelpUrlByCategory('extensions');
    $scope.UserPrompts_LearnMoreLinkHref = HelpService.getServerHelpUrlByCategory('extensions');
    $scope.learnMoreAnalyticsExtUrl = HelpService.getServerHelpUrlByCategory('analytics_extension');

    // set up behavior for safelist entries
    $scope.addNewSafelistEntry = ($event: JQuery.Event) => {
      this.preventFormSubmission($event);
      if (!this.$scope.extensionsSettingsFormModel.site.safeList) {
         // ???
      } else {
        this.removeDefaultEntries(List.SafeList);
        this.$scope.extensionsSettingsFormModel.site.safeList.unshift(_.clone(defaultEntry));
      }
    };

    $scope.deleteSafelistEntry = (index: number) => {
      if (!this.$scope.extensionsSettingsFormModel.site.safeList
        || this.$scope.extensionsSettingsFormModel.site.safeList.length < 1) {
        //??
      } else {
        // we don't want to show a confirm dialog because we're not going to save the list until you hit save on the page
        this.$scope.extensionsSettingsFormModel.site.safeList.splice(index, 1);
      }
    };

    // set up behavior for blocklist entries
    $scope.addNewBlocklistEntry = ($event: JQuery.Event) => {
      this.preventFormSubmission($event);
      if (!this.$scope.extensionsServerBlocklist){
        // log an error?
      } else {
        // remove any default entries so we don't build a list of ten default urls
        this.removeDefaultEntries(List.BlockList);
        this.$scope.extensionsServerBlocklist.unshift({ value: defaultUrl.valueOf()});
        this.refreshBlocklistForServer();
      }
    };

    $scope.deleteBlocklistEntry = (index: number) => {
      if (!this.$scope.extensionsServerBlocklist || this.$scope.extensionsServerBlocklist.length < 1) {
        // log an error?
      } else {
        // we don't want to show a confirm dialog because we're not going to save the list until you hit save on the page
        this.$scope.extensionsServerBlocklist.splice(index, 1);
        this.refreshBlocklistForServer();
      }
    };
  }

  // some methods can be triggered by a button click or by hitting Enter
  //  we want to avoid letting the "Enter" trigger form submission
  private preventFormSubmission($event: JQuery.Event){
      $event && (typeof $event.preventDefault === 'function') && $event.preventDefault();
  }

  private isDefaultUrl(value: string) {
     return (value.indexOf(defaultUrl) === 0 && value.length === defaultUrl.length);
  }

  private refreshBlocklistForServer(){
    this.$scope.extensionsSettingsFormModel.server.blocklist = _.map(this.$scope.extensionsServerBlocklist, (object) => object.value);
  }

  private getExtensionSettingsUpdatePromise(): ng.IPromise<any> {

    this.refreshBlocklistForServer();

    if (this.$scope.siteMatchesServer) {
      this.$scope.extensionsSettingsFormModel.site.extensionsEnabled =
        this.$scope.extensionsSettingsFormModel.server.extensionsGloballyEnabled;
    }
    const settings = this.$scope.extensionsSettingsFormModel;

    this.$scope.localForm.busy = true;
    let errors: IError[] = [];
    let serverUpdate: ng.IPromise<void>;
    let siteUpdate: ng.IPromise<void>;
    if (this.$scope.showServerSettings){
      serverUpdate = this.serverSettings.updateExtensionsSettings(settings.server).then((result: IResult) => {
        if (result.errors && result.errors.length) {
          errors = errors.concat(result.errors);
          this.$scope.sharedForm.state.updateFailure(errors, null);
          return this.$q.reject();
        } else {
          this.updateServerSuccess(settings.server, this.master);
          return this.$q.resolve();
        }
      });
    } else {
      serverUpdate = this.$q.when();
    }

    if (this.$scope.showSiteSettings){
       let x = Sites.instance.updateCurrentExtensionsSiteSettingsForSiteAdmin(settings.site);
       siteUpdate = x.then((result: IResult) => {
          if (result.errors && result.errors.length) {
            errors = errors.concat(result.errors);
            this.$scope.sharedForm.state.updateFailure(errors, null);
            return this.$q.reject();
          } else {
            this.updateSiteSuccess(settings.site, this.master);
            return this.$q.resolve();
          }
        });
    }
    else {
      siteUpdate = this.$q.when();
    }
    return this.$q.all([siteUpdate, serverUpdate])
      .finally(() => this.$scope.localForm.busy = false);
  }

  private UpdateExtsvcServerSettings(): ng.IPromise<IResult> {
    let errors: IError[] = [];
    const settings: IExtsvcServerSettings = { enabled: this.$scope.extensionsSettingsFormModel.analyticsExtServerEnabled.enabled };
    // if this is site page, do not call update server
    if (this.$scope.showSiteSettings){
      return;
    }
    return this.serverSettings.updateExtsvSettings(settings).then((result: IResult) => {
      if (result.errors && result.errors.length) {
        errors = errors.concat(result.errors);
        this.$scope.sharedForm.state.updateFailure(errors, null);
        return result;
      } else {
        this.master.analyticsExtServerEnabled = settings;
        return result;
      }
    });
  }

  private updateSiteSuccess(site: IExtensionsSiteSettings, master: IExtensionsSettings): void {
    // Only need to update current view and state if we're in server or site settings
    if (!NavLocationSelectors.inSettingsLocation(getAppStore().getState())) {
      return;
    }
    master.site = angular.copy(site);
  }

  private updateServerSuccess(server: IExtensionsServerSettings, master: IExtensionsSettings): void {
    // Only need to update current view and state if we're in server or site settings
    if (!NavLocationSelectors.inSettingsLocation(getAppStore().getState())) {
      return;
    }
    master.server = angular.copy(server);
  }

  private removeDefaultEntries(list: List): void {
    switch(list) {
      case List.BlockList: {
        this.$scope.extensionsServerBlocklist =  _.filter(this.$scope.extensionsServerBlocklist, (entry: EditableBlocklistItem) => !this.isDefaultUrl(entry.value));
        break;
      }
      case List.SafeList: {
        this.$scope.extensionsSettingsFormModel.site.safeList =  _.filter(this.$scope.extensionsSettingsFormModel.site.safeList, (entry: ExtensionSafeListEntry) => !this.isDefaultUrl(entry.url));
        break;
      }
    }
  }
}
